/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Features_CarouselInputs */



/**
* | output |
* | --- |
* | "New features carousel" |
*
* @param {New_Features_CarouselInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_features_carousel = /** @type {((inputs?: New_Features_CarouselInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Features_CarouselInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Carrousel des nouveautés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Karussell mit neuen Funktionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carosello delle nuove funzionalità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Карусель новых функций")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carrusel de nuevas funciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新功能轮播")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新機能カルーセル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई सुविधाओं का हिंडोला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novos recursos do carrossel")
	return /** @type {LocalizedString} */ ("New features carousel")
});